import { Cidade, Conta, Regiao, Upload } from "src/types";
import { ComponenteProjetoComQuantidade } from "./edicao/types";
import { ContaType } from "src/providers/cadastros/ContaProvider/types";
import { DadosFinalizar } from "./containers/TermosFinalizar";
import { SITUACAO_COMPONENTE } from "./EdicaoAvancada/type";
import { ImpostoItem } from "src/providers/cadastros/RoiPaybackImpostosProvider";
import { ConcessionariaItem } from "src/providers/cadastros/ConcessionariasProvider";
import { Componente, Contato, FormaPagamento, Modificado, NFContaOrdem, Notificacao } from "../vendas/types";
import { DOCUMENTOS_SERVICO_TYPE } from "./constants";
import IntegradorSolar from './personalizados/containers/Finalizacao/containers/ModalFaturamento/assets/integrador.png'
import IntegradorSolarClienteFinal from './personalizados/containers/Finalizacao/containers/ModalFaturamento/assets/integrador_cliente.png'
import ClienteFinal from './personalizados/containers/Finalizacao/containers/ModalFaturamento/assets/cliente.png'
import { RegiaoParametroComponente } from "../componentes/types";

export type ProjetoServico = "revenda" | "intelbras" | null
export type SegmentoType = "distribuicao_ongrid" | "distribuicao_offgrid" | "vertical_ongrid" | "vertical_offgrid" | "distribuicao_ambos" | null;
export type SetorType = "distribuicao_ongrid" | "distribuicao_offgrid" | "vertical_ongrid" | "vertical_offgrid" | null;
export type SituacaoType = "pendente" | "finalizado" | "expirado" | "cancelado" | "pausado";
export type PrioridadeType = "baixa" | "media" | "alta";

export type EtapaProjetoType = "aguardando_faturamento" | "aguardando_pagamento" | "analise_financiamento" |"cancelado" | "em_transito" | "entregue" | "faturado" | "negociacao" | "pre_orcamento" | "processando" | "reconhecido" | "sla_engenharia";

export type FaturamentoType = 'cliente' | 'integrador' | 'integrador_cliente'
export type ProjetoTipoType = "vertical" | "personalizado" | "dimensionado" | "avulso" | "kit" | "misto" | "dimensionado_hibrido" | "personalizado_hibrido"
export type PropostaValueType = 'gerador-sem-instalacao' | 'gerador-com-instalacao'
export type PosicaoModulo = 'paisagem' | 'retrato' | 'ambos'
export type ShortMonthNameType = 'Jan' | 'Fev' | 'Mar' | 'Abr' | 'Mai' | 'Jun' | 'Jul' | 'Ago' | 'Set' | 'Out' | 'Nov' | 'Dez'
export type LongMonthNameType = 'Janeiro' | 'Fevereiro' | 'Março' | 'Abril' | 'Maio' | 'Junho' | 'Julho' | 'Agosto' | 'Setembro' | 'Outubro' | 'Novembro' | 'Dezembro'
export type TiposInversorTypes = 'string' | 'micro'
export type ModoCalculoTypes = 'potencia' | 'consumo'
export type TipoProposta = 'simplificada' | 'detalhada'

export interface Consumo {
    day: string;
    value: number;
  }

export interface Option<T = string> {
    text: string;
    value: T;
}
export interface OptionWithImage<T = string> extends Option<T> {
    image: string;
    disabled?: boolean;
}

export interface OptionWithEstrutura<T = string> extends Option<T> {
    image: string;
    estruturas_grupo_id?: number;
    exibir_popup_parceiro?: boolean;
}

export interface Fileira {
    posicao_modulo: OptionWithImage<PosicaoModulo> | null;
    quantidade_modulos: number;
    fileiras: number;
    tipo_estrutura: OptionWithEstrutura<number> | null;
}

export interface DadosTermo {
    user_id?: number | string;
    texto: string[] | string;
    aceito_em: string;
    user_name?: string;
}

export interface Projeto {
    valor_total_produtos: number;
    "@proposta_atualizada"?: boolean;
    data_pagamento_comissionamento?: string;
    notificacoes_pagamento?: any[]
    acessoriosSugeridos?: Array<{ id: number; quantidade: number; categoria_componentes_id: number }>;
    acessorios?: ListagemItem[];
    analista_id?: number | null;
    analista_nome?: string;
    analista?: Conta;
    anexos?: Anexo[] | null;
    area_total?: number;
    assistente_id?: number;
    assistente?: Conta;
    auto_comissao: boolean;
    bairro: string | null;
    calculo?: IProjetosDadosCalculo;
    carrinho_id?: number;
    cep_encontrado: boolean;
    cep: string | null;
    cidade_id?: number;
    cidade_nome?: string;
    cidade?: Cidade | null;
    cliente_proposta: string;
    codigo_venda?: string | null;
    componentes_finame?: any[]
    componentes?: ComponenteProjeto[] | null;
    componentes_modificados?: ProjetosComponentesModificados[] | null;
    componentes_originais?: ProjetosComponentesOriginais[] | null;
    confirmado_por: any;
    consideracao?: string;
    consumo_data_final: Date | null;
    consumo_data_inicial: Date | null;
    consumo_meses: Consumo[];
    cpf_cnpj_proposta?: string;
    cpf_proposta?: string;
    created_at?: string | null;
    dados_finalizar?: DadosFinalizar;
    dados_termo?: DadosTermo;
    data_etapa_venda?: string | null;
    data_expiracao?: string;
    data_integracao?: string | null;
    data_visita_tecnica: any;
    descontos?: Desconto[];
    disposicoes?: Disposicao[] | null;
    distribuidor_id?: number | null;
    distribuidor?: Conta | null;
    documentos_servico?: DocumentosServicoUpload[]
    email_proposta: string;
    endereco_proposta?: string;
    endereco: any;
    estado_id?: string;
    estado?: { id: string, nome?: string };
    estado_original?: { id: string, nome?: string };
    estrutura_calculadas: ListagemItem[];
    estruturas_edicao: any[];
    estruturasSelecionadas?: EstruturaListagem[];
    etapa_venda?: string;
    ev_id?: number | null;
    ev_nome?: string;
    ev?: Conta;
    fantasia_distribuidor?: string;
    fantasia_revenda?: string;
    fator_perdas: number;
    fileiras_edicao: Fileira[];
    fileiras: Fileira[];
    geradores_kits: Gerador[];
    id?: number;
    inversoresList?: ListagemItem[];
    controladoresList?: ListagemItem[];
    carregadoresList?: ListagemItem[];
    isEdit: boolean;
    latitude: number;
    limitacao_projeto?: LimitacaoProjeto;
    lista_termo_simulacao_financiamento_original: ListaTermoSimulacaoFinanciamento | null;
    lista_termo_simulacao_financiamento: ListaTermoSimulacaoFinanciamento | null;
    longitude: number;
    modo_calculo: ModoCalculoTypes;
    modulosList?: ModuloListagem[];
    nota_fiscal_triangular: boolean;
    numero_fases: Option<number> | null
    numero: string | null;
    observacao_sorps?: string;
    observacao?: string;
    old_componentes_edicao: ComponenteProjetoComQuantidade[]
    old_estado_id: string;
    pagamentos: any;
    pedidos?: any;
    percentual_comissao_distribuidor: number;
    percentual_comissao_distribuidor_sap: number;
    percentual_comissao_revenda: number;
    percentual_comissao_revenda_sap: number;
    peso_gerador?: number;
    peso_telhado?: number;
    potencia_desejada: number;
    potencia_gerador?: number;
    potencia_inversor?: number;
    potencia?: number;
    preco_kwh_com_imposto: number;
    preco_kwh_com_imposto_original?: number;
    preco_kwh?: number;
    prioridade?: string;
    quantidade_kits?: number;
    recebe_servico?: boolean;
    regioes: Regiao[];
    resultado_calculos?: ResultadoCalculos | null
    revenda_id?: number | null;
    revenda?: Conta | null;
    segmento?: SegmentoType;
    servico: ProjetoServico;
    setor?: SetorType;
    showRoiPayback: boolean;
    simulacao_financiamento: SimulacaoFinanciamento | null
    simultaneidade: number
    situacao: SituacaoType;
    solicitacao?: ProjetoSolicitacoes;
    solucao_sugerida: any;
    sugestoes: Sugestao;
    supervisor_id?: number | null;
    supervisor?: Conta;
    telefone_proposta?: string;
    tempo_garantia_servico_unidade: { text: string; value: string } | null;
    tempo_garantia_servico: number;
    tempo_vida: string;
    tensao_rede: Option<number> | null
    termo_aceito: boolean;
    texto_termo_aceito: string;
    destino?: FaturamentoType;
    tipo_faturamento: FaturamentoType;
    tipo_inversor: { text: string; value: number } | null;
    tipo_solucao?: { text: string; value: number } | null;
    inversor_modelo: OptionWithImage<string> | null;
    tipo_projeto: Option | null;
    tipo_proposta_projeto?: TipoProposta;
    tipo_proposta: Option<PropostaValueType> | null;
    tipo?: ProjetoTipoType
    titulo?: string | null;
    uf?: string;
    updated_at?: string | null;
    uploads?: Upload[] | null;
    url_pagamento?: string;
    user_guilted_id?: null | number;
    valor_anual_manutencao: number;
    valor_comissao_revenda?: number;
    valor_desconto: number;
    valor_margem_produtos: number;
    valor_pedido: number;
    valor_projeto?: number;
    valor_servico_pis_cofins?: number;
    valor_servico?: number;
    valor?: number;
    vendedor_interno?: Option<number>
    visita_tecnica_texto_id?: number | null
    migrado?: boolean;
    origem?: string;
    data_criacao?: string;
    visita_tecnica_texto: any;
    dados_visita_tecnica?: any;
    dados_migracao?: any;
    status_projeto?: string;
    status_projeto_pagamento?: string;
    recalcular?: boolean;
    reativar?: boolean;
    engenharia?: boolean;
    alterou_segmento?: boolean;
    editado_admin?: boolean;
    historico?: IProjetoPagamentosHistorico[];
    tarifa_concessionaria_id: number;
    tarifa_concessionaria_id_original?: number;
    status_comissionamento?: string
    impostos_payback: ImpostoItem | null
    dados_concessionaria_payback: ConcessionariaItem | null
    historicos_migrado?: any[];
    tipo_proposta_envio?: string | any;
    alterou_inversor?: boolean | any;
    alterou_modulo?: boolean | any;
    retornou_tela?: boolean | any;
    carrinho?: ICarrinhosProjeto[];
    isTrocaUf?: boolean;
    codigo_servico?: string;
    dados_finalizar_renovigi?: DadosFinalizarRenovigi | null;
    clonado?: {
        projeto_origem_id: number
        data_clonagem: string
        criador: {
            id: number
            nome: string
        }
        termos_clonagem: {
            texto: string[]
            user_id: string
            aceito_em: string
        }
        created_at: string
        updated_at: string
    }
    clonar_projeto?: boolean
    justificativa_valor_servico?: string | null
    data_envio_link_pagamento?: string | Date
    corrente_reversa?: boolean;
    divergencia_strings?: boolean;
    sugestao_instalacao?: SugestaoInstalacao | null
    avulsos?: any;
}

export interface SugestaoInstalacao {
    user_id?: number
    texto?: string
    alerta?: string
    confirmado_em?: string
    user_name?: string
}

export interface DadosFinalizarRenovigi {
    user_id: number
    observacao: string
    finalizado_em: string
    user_name: string
}

export interface ICarrinhosProjeto {
    id:              number;
    guid:            string;
    codigo_venda:    string;
    observacao:      null;
    user_guilted_id: number;
    created_at:      Date;
    updated_at:      Date;
    itens:           ICarrinhosItemProjeto[];
    avulsos?:          any[];
}

export type ICarrinhosItemProjeto = {
    id:                    number;
    nome:                  string;
    segmento:              string;
    tipo:                  string;
    quantidade:            number;
    valor:                 number;
    comissao_distribuidor: number;
    fator:                 number;
    user_guilted_id:       number;
    created_at:            Date;
    updated_at:            null;
}


export interface IProjetoPagamentosHistorico {
    pagamento_id: number,
    valor: number,
    data_criacao_pagamento: Date | string,
    data_atualizacao_pagamento: Date | string,
    situacao: string,
    forma_pagamento_id: number,
    dados_integracao?: {
        cartao_credito: [{
            bandeira: string,
            parcelas: number,
            valor: number,
            observacao: string,
            situacao: string,
        }],
        boleto: {
            valor: number,
            observacao: string,
            situacao: string,
            data_vencimento: Date | string
        },
        pix: {
            valor: number,
            observacao: string,
            situacao: string,
            data_expiracao: Date | string
        },
        carta_credito: {
            banco: number,
            etapa_financiamento: string,
            situacao: string,
            situacao_carta: string,
            situacao_comprovante: string
        },
        financiamento: {
            financeira: string,
            taxa: number,
            carencia: number,
            valor_parcela: number,
        }
    }
}

export interface ProjetosComponentesOriginais {
    id:                       number;
    projeto_id:               number;
    componente_id:            number;
    quantidade:               number;
    valor_unitario:           number;
    valor_unitario_original:  number;
    origem:                   string;
    created_at:               Date;
    updated_at:               null;
    user_guilted_id:          number;
    modelo:                   string;
    categoria_componentes_id: number;
}

export interface ProjetosComponentesModificados {
    id?:                       number;
    projeto_id:                number;
    componente_id:             number;
    componente_substituido_id: number | null;
    situacao:                  SITUACAO_COMPONENTE;
    quantidade:                number;
    quantidade_original?:      number;
    valor_unitario:            number;
    valor:                     number;
    valor_original?:           number;
    readonly created_at?:      string | null;
    readonly updated_at?:      string | null;
    readonly user_guilted_id?: number;
    modelo:                    string;
    categoria_componentes_id:  number;
}


export interface IProjetosDadosCalculo {
    componentes: IComponentesCalculo;
    modificados: IComponentesCalculo;
}

export interface IComponentesCalculo {
    area_total:       number;
    peso_gerador:     number;
    peso_telhado:     number;
    valor:            number;
    potencia_gerador: number;
}


export interface IComponentesFiname {
    componente_id: number;
    codigo_finame: string;
}

export interface GeradorItem extends ListagemItem {
    id: string | number;
}
  
export interface Gerador {
    id: string | number;
    nome: string;
    quantidade: number;
    fator?: number;
    items: GeradorItem[];
}

export interface SimulacaoParcelaItem {
    parcela: number;
    valor: number;
}

export interface SimulacaoFinanceira {
    financeira: string;
    parcelas: SimulacaoParcelaItem[]
}

export interface SimulacaoFinanciamento {
    dataNascimentoOuFundacao: string;
    rendaOuFaturamentoMensal: number;
    financeira: string;
    valorFinanciado: number;
    simulacoes: SimulacaoFinanceira[];
    cpfCnpj: string;
}

export interface ListaTermoSimulacaoFinanciamento {
    termos: TermoSimulacaoFinanciamento[];
}

export interface TermoSimulacaoFinanciamento {
    termoSimulacaoFinanciamento: string;
    dataHora: string;
    novo: boolean;
}

export interface Sugestao {
    estrutura: {
        id: number;
        quantidade: number;
        categoria_componentes_id: number;
    }[],
    modulo: {
        id: number;
        quantidade: number;
        categoria_componentes_id: number;
    },
    inversores: {
        id: number;
        quantidade: number;
        categoria_componentes_id: number;
    }[],
    acessorios: {
        id: number;
        quantidade: number;
        categoria_componentes_id: number;
    }[]
}

export interface ResultadoCalculos {
    servicos: ResultadoServicos;
    componentes: ResultadoComponentes;
}

interface ResultadoServicos {
    valor_com_pis_cofins: number;
}

interface ResultadoComponentes {
    area_total: number;
    peso_gerador: number;
    peso_telhado: number;
    valor?: any;
    potencia_gerador: number;
    potencia_inversor: number;
}

export type ProjetoSolicitacoes = {
    id?: number | null;
    projeto_id?: number | null;
    endereco?: string;
    unidade_consumidora: boolean;
    limitacao_observacao?: string;
    limitacao_projeto_id?: number | null;
    grupos_estruturas?: string;
}

export type LimitacaoProjeto = {
    id?: number | null;
    descricao?: string
}

export type VerticaisExtra = {
    valor?: number;
    valor_servico?: number;
    valor_servico_pis_cofins?: number;
    area_total?: number;
    peso_gerador?: number;
    peso_telhado?: number;
    potencia_gerador?: number;
    potencia_inversor?: number;
    estruturas?: GrupoEstrutura[];
}


export type Anexo = {
    id?: number | null;
    projeto_id?: number | null;
    url?: string | null;
    descricao?: string | null;
    created_at?: string | null;
    updated_at?: string | null;
    "@remove"?: boolean;
}

export type Disposicao = {
    grupo_estrutura_id?: number | null;
    "@remove"?: boolean;
    created_at?: string | null;
    updated_at?: string | null;
}

export type Desconto = {
    id?: number | null;
    tipo: string;
    percentual: string;
    "@remove"?: boolean;
    created_at?: string | null;
    updated_at?: string | null;
}

export type GrupoEstrutura = {
    "@remove"?: boolean;
    id?: number | null;
    distribuicao?: boolean;
    nome: string;
    paisagem?: boolean;
    retrato?: boolean;
    updated_at?: string | null;
    created_at?: string | null;
    vertical?: boolean;
}

export type ComponenteProjeto = {
    componente: any;
    componente_id: number
    modelo: string;
    quantidade: number;
    valor_unitario: number;
    valor_unitario_original: number;
    fator: number;
    dados_migracao?: any;
    deleted_at?: any;
    nome_categoria?: string;
    grupo_categoria?: string;
    ordem_listagem?: number;
}

export interface ServicoCalcular {
    tipo: ProjetoServico;
    valor_margem_produtos?: number;
    valor: number;
}

export interface ComponenteCalcular {
    componente_id: number;
    quantidade: number;
    quantidade_original?: number;
    valor: number;
    categoria_componentes_id: number;
    peso: number;
    altura: number;
    largura: number;
    potencia: number;
}

export interface DisposicoesSalvar {
    grupo_estrutura_id: number
}

export interface ProjetoCalcular {
    carrinho_id?: number;
    servicos: ServicoCalcular;
    componentes: ComponenteCalcular[];
    estado_id: string;
    tipo?: ProjetoTipoType;
    segmento?: SegmentoType;
    regioes?: number[];
    projeto_id?: number;
    revenda_id?: number;
    distribuidor_id?: number;
    recalcular?: boolean;
    reativar?: boolean;
}

export interface Atributo {
    atributo: string;
    valor: string;
}

export interface ModuloPorRegiaoListagemResponse {
    id: number;
    categoria_componentes_id: number;
    modelo: string;
    nome: string;
    nome_componente: string;
    descricao: string;
    descricao_componente: string;
    segmento: string;
    peso: number;
    tempo_garantia: number;
    tempo_garantia_unidade: string;
    venda: string;
    considerar_calculo: boolean;
    exibir_listagem: boolean;
    comprimento: number;
    largura: number;
    altura: number;
    created_at: string;
    updated_at: string;
    categoria_componentes_nome: string;
    data_previsao_faturamento?: string;
    dias_previsao_faturamento?: string;
    expedicao: boolean;
    deposito: string;
    atributos: Atributo[]
    inversores: CustomInversores[]
    regioes_parametros?: RegiaoParametroComponente[];
    finame?: boolean;
    parceito_id?: number;
    exibir_popup_parceiro?: boolean;
}

export interface Bateria {
    id: number
    categoria_componentes_id: number
    modelo: string
    nome: string
    nome_componente: string
    descricao: string
    descricao_componente: string
    segmento: string
    peso: number
    tempo_garantia: number
    tempo_garantia_unidade: string
    venda: string
    considerar_calculo: boolean
    exibir_listagem: boolean
    comprimento: number
    largura: number
    altura: number
    origem: string
    unidade_medida: string
    grupo_mercadoria: string
    parceiro_id: number
    exibir_popup_parceiro: boolean
    descricao_garantia: string
    created_at: string
    updated_at: string
    atributos: { atributo: string, valor: string }[]
    tipo: 1 | 2
    tensao_nominal: number
    capacidade: number
    potencia: number
}

export interface CustomInversores {
    id: number;
    modulo_id: number;
    nome: string;
    categoria_componentes_id: number;
    categoria_componentes_nome: string;
}


export interface InversorModuloResponse {
    id: number;
    categoria_componentes_id: number;
    modelo: string;
    nome: string;
    nome_componente: string;
    descricao: string;
    descricao_componente: string;
    segmento: string;
    peso: number;
    tempo_garantia: number;
    tempo_garantia_unidade: string;
    venda: string;
    considerar_calculo: boolean;
    exibir_listagem: boolean;
    comprimento: number;
    largura: number;
    altura: number;
    potencia_maxima_saida?: number;
    atributos: Atributo[]
    created_at: string;
    updated_at: string;
    exibir_popup_parceiro: boolean;
}

export interface VinculoModuloResponse {
    id: number;
    categoria_componentes_id: number;
    modelo: string;
    nome: string;
    nome_componente: string;
    descricao: string;
    descricao_componente: string;
    segmento: string;
    peso: number;
    tempo_garantia: number;
    tempo_garantia_unidade: string;
    venda: string;
    considerar_calculo: boolean;
    exibir_listagem: boolean;
    comprimento: number;
    largura: number;
    altura: number;
    potencia_maxima_saida?: number;
    atributos: Atributo[]
    created_at: string;
    updated_at: string;
    exibir_popup_parceiro: boolean;
}

export interface EstruturaListagemResponse {
    id:                  number;
    estruturas_grupo_id: number;
    nome:                string;
    url_imagem:          string;
    status:              boolean;
    inversor:            string;
    segmento:            string;
    grupos:              Grupo[];
    posicao:             string | null;
    exibir_popup_parceiro: boolean;
    editada?: boolean;
}

export interface Grupo {
    id:           number;
    estrutura_id: number;
    nome:         string;
    url_imagem:   string;
    status:       boolean;
    segmento:     string;
    inversor:     string;
    posicao:      string;
    sequencial:   number;
    permite_fileiras?:   boolean;
    componentes:  ComponenteEstrutura[];
}

export interface ComponenteEstrutura {
    id:                       number;
    estruturas_grupo_id:      number;
    categoria_componentes_id: number;
    modelo:                   string;
    nome:                     string;
    nome_componente:          string;
    descricao:                string;
    descricao_componente:     string;
    segmento:                 string;
    peso:                     number;
    tempo_garantia:           number;
    tempo_garantia_unidade:   string;
    venda:                    string;
    considerar_calculo:       boolean;
    exibir_listagem:          boolean;
    comprimento:              number;
    largura:                  number;
    altura:                   number;
    exibir_popup_parceiro:    boolean;
}

export interface ModuloListagem extends ListagemItem {
    faturamento?: string;
    selecionado: boolean;
    categoria: string;
    inversoresTipos: string[];
    comprimento: number;
    potenciaMaxima?: number;
    potenciaMinima?: number;
    tensaoVocModulo?: number;
    finame?: boolean;
    regioes_parametros?: RegiaoParametroComponente[];
    exibir_popup_parceiro?: boolean;
  }

export interface EstruturaListagem  {
    nome: string
    id: number
    opened?: boolean
    status?: boolean
    posicao?: string
    estrutura_id?: number
    componente_id?: number
    quantidade?: number
    estruturas_grupo_id: number;
    exibir_popup_parceiro?: boolean;
    items: ListagemItem[]
}
  
export interface ListagemItem extends ComponenteCalcular {
    nome: string;
    modelo?: string;
    descricao: string;
    maximaPotenciaFV?: number;
    potenciaMaximaEntradaCC?: number;
    tensaoMaximaEntrada?: number;
    estruturas_grupo_id?: number;
    valor_unitario: number;
    exibir_listagem?: boolean;
    exibir_popup_parceiro?: boolean;
    atributos?: any[];
    "@remove"?: true;
    regra_indicacao?: any[];
}

export interface ProjetosDescontos {
    desconto_revenda: number,
    desconto_distribuidor: number,
    desconto_intelbras: number,
    historico: ProjetosDescontosHistorico[]
}

export interface ProjetosDescontosHistorico {
    percentual_distribuidor: number,
    percentual_revenda: number,
    percentual_intelbras: number,
    created_at?: string | Date,
    justificativa?: string,
    nome_usuario?: string,
    valor_desconto_intelbras: number,
}

export type ModalProposta = {
    codigo_venda: string 
    projetoId: number;
    valoresUnitarios?: boolean;
    url: string,
    tipo?: string,
}

export interface TermosAceiteVisitaTecnica {
    texto: string,
    itens?: { texto: string }[]
}

export interface THistoricoProjeto {
    analista_id:                      null;
    assistente_id:                    number;
    auto_comissao:                    boolean;
    cidade_id:                        number;
    cliente_proposta:                 string;
    codigo_venda:                     string;
    componentes?:                     THistoricoComponente[] | null;
    cpf_cnpj_proposta:                string;
    created_at:                       string | null;
    dados_finalizar?:                 DadosFinalizar | null;
    dados_termo?:                     DadosTermo | null;
    data_cancelamento:                string | null;
    data_etapa_venda:                 string | null;
    data_expiracao:                   string | null;
    data_solicitacao_pausa:           null;
    destino:                          string;
    distribuidor_id:                  number;
    distribuidor?:                    ContaType | null;
    email_proposta:                   string;
    endereco_proposta:                string;
    endereco?:                        TProjetoEndereco;
    etapa_venda:                      string;
    ev_id:                            number;
    id:                               number;
    migrado?:                         boolean;
    motivo_pausa:                     null;
    observacao:                       string;
    origem:                           string;
    percentual_comissao_distribuidor: number;
    percentual_comissao_revenda:      number;
    potencia_inversor:                number;
    potencia:                         number;
    preco_kwh:                        null;
    prioridade:                       string;
    revenda_id:                       null;
    revenda?:                         ContaType | null;
    segmento:                         string;
    servico:                          string;
    simulacao_financiamento:          null;
    situacao:                         string;
    solucao_sugerida:                 TSolucaoSugerida;
    supervisor_id:                    number;
    telefone_proposta:                string;
    tempo_garantia_servico_unidade:   null;
    tempo_garantia_servico:           null;
    tipo_faturamento:                 null;
    tipo:                             string;
    titulo:                           string;
    user_guilted_id:                  number;
    usuario:                          string;
    valor_anual_manutencao:           null;
    valor_desconto:                   null;
    valor_margem_produtos:            null;
    quantidade_kits:                  0;
    valor_projeto:                    number;
    valor_servico_pis_cofins:         number;
    valor_servico:                    number;
    valor:                            number;
    termos_aceite:                    string[] | TermosAceiteVisitaTecnica[];
    visita_tecnica_texto_id?: number | null
}

export interface THistoricoComponente {
    componente_id:           number;
    created_at:              Date;
    id:                      number;
    projeto_id:              number;
    quantidade:              number;
    user_guilted_id:         number;
    usuario:                 string;
    valor_unitario_original: number;
    valor_unitario:          number;
}

export type TSolucaoSugerida = {
    consumo:               TConsumo[];
    fileiras:              TFileira[];
    inversor:              number;
    potencia:              number;
    regiao_id:             number[];
    componentes:           TComponente[];
    fator_perdas:          number;
    tipo_projeto:          string;
    tipo_inversor:         number;
    inversor_modelo:       string;
    inversor_tensao:       number;
    inversor_tipo_conexao: number;
}

export type TComponente =  {
    id:                       number;
    quantidade:               number;
    categoria_componentes_id: number;
}

export type TConsumo = {
    dia:     string;
    consumo: string;
}

export type TFileira =  {
    posicao:           string;
    estrutura_id:      string;
    fileiras_iguais:   number;
    modulos_sequencia: string;
}

export type TPedido =  {
    cliente_endereco_id:           null;
    cliente_id:                    null;
    codigo_venda:                  string;
    created_at:                    string | null;
    cupom_desconto:                string | null;
    data_etapa_pedido:             string | null;
    data_expiracao_cupom_desconto: string | null;
    data_expiracao_pagamento:      string | null;
    data_expiracao:                string | null;
    data_pagamento:                string | null;
    data_previsao_faturamento:     string | null;
    estabelecimento_id:            number | null;
    etapa_pedido:                  string;
    forma_pagamento_id:            null;
    id:                            number;
    pedido_erp:                    string | null;
    projeto_id:                    number;
    rastreamentos?:                TRastreamentoPedido[];
    restricao:                     string | null;
    situacao:                      string;
    user_guilted_id:               number;
    usuario_whatsapp:              string | null;
    valor_desconto:                number;
    valor_pagamento:               number;
    valor_pedido:                  number;
    termos_aceite?:                IPedidosTermosAceiteDom[];
    notas_fiscais?:                TNotaFiscal[];
    
}

export type THistoricoPedido = TPedido & {
    rastreamentos: TRastreamentoPedido[];
    componentes?:   THistoricoComponente[];
    nota_fiscal?: TNotaFiscal;
}


export interface TRastreamentoPedido {
    id:                 number;
    pedido_id:          number;
    data_rastreamento:  Date;
    ocorrencia:         string;
    observacao:         string;
    link_rastreio:      string;
    status_finalizador: boolean;
    created_at:         Date;
}
export interface ProjetosDescontos {
    desconto_revenda: number,
    desconto_distribuidor: number,
    desconto_intelbras: number,
    historico: ProjetosDescontosHistorico[]
}

export interface ProjetosDescontosHistorico {
    percentual_distribuidor: number,
    percentual_revenda: number,
    percentual_intelbras: number,
    created_at?: string | Date,
    justificativa?: string,
    nome_usuario?: string,
}

export interface DocumentosServicos {
    documentos_servico: DocumentosServicosArquivo[],
    status_comissionamento?: string,
    data_pagamento_comissionamento?: string
}

export enum STATUS_DOCUMENTO {
    APROVADO = "aprovado",
    RECUSADO = "recusado",
    PENDENTE = "pendente",
}

export interface DocumentosServicoUpload {
    url: string,
    tipo: DOCUMENTOS_SERVICO_TYPE,
    created_at?: string | Date,
    status_documento: STATUS_DOCUMENTO
}

export interface DocumentosServicosArquivo {
    url: string,
    tipo: string,
    status_documento: string
}


export type TNotaFiscal = {
    chave_acesso_nfe:  string;
    created_at:        string | null;
    data_emissao:      string | null;
    id:                number;
    itens?:            TItenNotaFical[];
    natureza_operacao: string;
    numero:            number;
    origem:            string;
    pedido_id:         number;
    peso_bruto:        number;
    serie:             number;
    situacao:          string;
    updated_at:        string | null;
    valor:             number;
}

export type TItenNotaFical = {
    codigo:     string;
    created_at: string | null;
    id:         number;
    nome:       string;
    quantidade: number;
    valor:      number;
}


export interface IPedidosTermosAceiteDom {
    readonly id?: number, 
    pedido_id: number, 
    codigo_venda: string, 
    texto: string, 
    aceito: boolean, 
    tipo: string, 
    financeira_id?: number, 
    codigo_intetgracao?: string, 
    data_aceite: string | Date, 
    readonly created_at?: string | Date, 
    readonly deleted_at?: string | Date, 
    readonly user_guilted_id?: number, 
}

export type TProjetoEndereco = {
    cidade_id:       number;
    estado_id:       string;
    cep:             string;
    bairro:          string;
    logradouro:      string;
    numero:          string;
    complemento:     null;
    latitude:        null;
    longitude:       null;
    created_at:      Date;
    updated_at:      Date;
    user_guilted_id: number;
}
export type TDadosBancariosConta = {
    numero_agencia: string;
    numero_banco:   string;
    numero_conta:   string;
}
export interface TProjetoHistorico {
    id:                 number, 
    projeto_id:         number, 
    projeto?:           ProjetoHistorico, 
    data_alteracao:     string | Date, 
    operacao:           string, 
    listar_historico:   boolean, 
    user_guilted_id:    number;
    usuario?:           string;
}
export interface TPedidoHistorico {
    id:                 number, 
    pedido_id:         number, 
    pedido?:           PedidoHistorico, 
    data_alteracao:     string | Date, 
    operacao:           string, 
    listar_historico:   boolean, 
    user_guilted_id:    number;
    usuario?:           string;
}
export interface PedidoHistorico {
    [key: string]: any;
    id?: number;
    codigo_venda: string;
    situacao: string;
    potencia: number;
    valor_pedido: number;
    valor_desconto: number;
    valor_pagamento: number;
    estabelecimento_id?: number;
    estabelecimento_modificado_id: number | null;
    justificativa: string | null;
    bloqueio: string | null;
    created_at: string | null;
    updated_at: string | null;
    usuario_id: number;
    codigo_pedido: string | null;
    data_integracao: string | null;
    distribuidor?: Contato;
    revenda?: Contato;
    cliente?: Contato;
    forma_pagamento?: FormaPagamento;
    ev?: Contato;
    componentes: Componente[];
    modificados: Modificado[];
    data_previsao_faturamento?: string | null;
    data_pagamento?: string | null;
    notificacoes?: Notificacao[];
    etapa_pedido?: string;
    nota_fiscal_conta_ordem?: NFContaOrdem,
    pedido_erp: any;
}
export interface ProjetoHistorico {
    [key: string]: any;
    "@proposta_atualizada"?: boolean;
    notificacoes_pagamento?: any[]
    acessorios?: ListagemItem[];
    analista_id?: number | null;
    analista_nome?: string;
    analista?: Conta;
    anexos?: Anexo[] | null;
    area_total?: number;
    assistente_id?: number;
    assistente?: Conta;
    auto_comissao: boolean;
    bairro: string | null;
    calculo?: IProjetosDadosCalculo;
    carrinho_id: number;
    cep_encontrado: boolean;
    cep: string | null;
    cidade_id?: number;
    cidade_nome?: string;
    cidade?: Cidade | null;
    cliente_proposta: string;
    codigo_venda?: string | null;
    componentes_finame?: any[]
    componentes?: ComponenteProjeto[] | null;
    componentes_modificados?: ProjetosComponentesModificados[] | null;
    componentes_originais?: ProjetosComponentesOriginais[] | null;
    confirmado_por: any;
    consideracao?: string;
    consumo_data_final: Date | null;
    consumo_data_inicial: Date | null;
    consumo_meses: Consumo[];
    cpf_cnpj_proposta?: string;
    cpf_proposta?: string;
    created_at?: string | null;
    dados_finalizar?: DadosFinalizar;
    dados_termo?: DadosTermo;
    data_etapa_venda?: string | null;
    data_expiracao?: string;
    data_integracao?: string | null;
    data_visita_tecnica: any;
    descontos?: Desconto[];
    disposicoes?: Disposicao[] | null;
    distribuidor_id?: number | null;
    distribuidor?: Conta | null;
    documentos_servico?: DocumentosServicoUpload[]
    email_proposta: string;
    endereco_proposta?: string;
    endereco: any;
    estado_id?: string;
    estado?: { id: string, nome?: string };
    estrutura_calculadas: ListagemItem[];
    estruturas_edicao: any[];
    estruturasSelecionadas?: EstruturaListagem[];
    etapa_venda?: string;
    ev_id?: number | null;
    ev_nome?: string;
    ev?: Conta;
    fantasia_distribuidor?: string;
    fantasia_revenda?: string;
    fator_perdas: number;
    fileiras_edicao: Fileira[];
    fileiras: Fileira[];
    geradores_kits: Gerador[];
    id?: number;
    inversoresList?: ListagemItem[];
    isEdit: boolean;
    latitude: number;
    limitacao_projeto?: LimitacaoProjeto;
    lista_termo_simulacao_financiamento_original: ListaTermoSimulacaoFinanciamento | null;
    lista_termo_simulacao_financiamento: ListaTermoSimulacaoFinanciamento | null;
    longitude: number;
    modo_calculo: ModoCalculoTypes;
    modulosList?: ModuloListagem[];
    nota_fiscal_triangular: boolean;
    numero_fases: Option<number> | null
    numero: string | null;
    observacao_sorps?: string;
    observacao?: string;
    old_componentes_edicao: ComponenteProjetoComQuantidade[]
    old_estado_id: string;
    pagamentos: any;
    pedidos?: any;
    percentual_comissao_distribuidor: number;
    percentual_comissao_revenda: number;
    peso_gerador?: number;
    peso_telhado?: number;
    potencia_desejada: number;
    potencia_gerador?: number;
    potencia_inversor?: number;
    potencia?: number;
    preco_kwh_com_imposto: number;
    preco_kwh?: number;
    prioridade?: string;
    quantidade_kits?: number;
    recebe_servico?: boolean;
    regioes: Regiao[];
    resultado_calculos?: ResultadoCalculos | null
    revenda_id?: number | null;
    revenda?: Conta | null;
    segmento?: SegmentoType;
    servico: ProjetoServico;
    setor?: SetorType;
    showRoiPayback: boolean;
    simulacao_financiamento: SimulacaoFinanciamento | null
    simultaneidade: number
    situacao: SituacaoType;
    solicitacao?: ProjetoSolicitacoes;
    solucao_sugerida: any;
    sugestoes: Sugestao;
    supervisor_id?: number | null;
    supervisor?: Conta;
    telefone_proposta?: string;
    tempo_garantia_servico_unidade: { text: string; value: string } | null;
    tempo_garantia_servico: number;
    tempo_vida: string;
    tensao_rede: Option<number> | null
    termo_aceito: boolean;
    texto_termo_aceito: string;
    destino?: FaturamentoType;
    tipo_faturamento: FaturamentoType;
    tipo_inversor: { text: string; value: number } | null;
    inversor_modelo: OptionWithImage<string> | null;
    tipo_projeto: Option | null;
    tipo_proposta_projeto?: TipoProposta;
    tipo_proposta: Option<PropostaValueType> | null;
    tipo?: ProjetoTipoType
    titulo: string;
    uf?: string;
    updated_at?: string | null;
    uploads?: Upload[] | null;
    url_pagamento?: string;
    user_guilted_id?: null | number;
    valor_anual_manutencao: number;
    valor_comissao_revenda?: number;
    valor_desconto: number;
    valor_margem_produtos: number;
    valor_pedido: number;
    valor_projeto?: number;
    valor_servico_pis_cofins?: number;
    valor_servico?: number;
    valor?: number;
    vendedor_interno?: Option<number>
    visita_tecnica_texto_id?: number | null
    migrado?: boolean;
    origem?: string;
    data_criacao?: string;
    visita_tecnica_texto: any;
    status_projeto?: string;
    status_projeto_pagamento?: string;
    recalcular?: boolean;
    reativar?: boolean;
    engenharia?: boolean;
    alterou_segmento?: boolean;
    editado_admin?: boolean;
    historico?: IProjetoPagamentosHistorico[];
    tarifa_concessionaria_id: number;
    status_comissionamento?: string
    impostos_payback: ImpostoItem | null
    dados_concessionaria_payback: ConcessionariaItem | null
    termos_aceite?: any;
    estabelecimento_id: number,
}
export interface TNotaHistorico {
    id: number, 
    pedido_id: number,
    numero?: number | any;
    valor?: number | any;
    peso_bruto?: number | any;
    user_guilted_id:    number;
    itens: TItenNotaFical[];
    estado?: string;
    cidade?: string;
    bairro?: string;
    logradouro?: string;
    numero_endereco?: string;
    complemento?: string;
    observacao?: string;
    updated_at?: string | null;
    created_at: string | null;
}

export type TPedidosHistoricos = {
    id:                            number;
    migrado:                       boolean;
    situacao:                      string;
    restricao:                     string;
    cliente_id:                    number;
    pedido_erp:                    string;
    projeto_id:                    number;
    codigo_venda:                  string;
    data_criacao:                  Date | string;
    etapa_pedido:                  string;
    valor_pedido:                  number;
    notas_fiscais:                 TPedidosHistoricosNotasFiscais[];
    cupom_desconto:                number;
    dados_migracao:                any;
    data_expiracao:                Date | string;
    data_pagamento:                Date | string;
    valor_desconto:                number;
    valor_pagamento:               number;
    usuario_whatsapp:              string;
    data_etapa_pedido:             Date | string;
    estabelecimento_id:            number;
    forma_pagamento_id:            number;
    situacao_pagamento:            string;
    cliente_endereco_id:           number;
    data_emissao_pedido_erp:       Date;
    dados_pagamentos_migrado:      object;
    data_expiracao_pagamento:      Date | string;
    data_previsao_faturamento:     Date | string;
    data_expiracao_cupom_desconto: Date | string;
    data_evento:                   Date | string;
    rastreamentos:                 TPedidosHistoricosRastreamento[];
    itens:                         TPedidosHistoricosComponentes[];
}

export type TPedidosHistoricosComponentes = {
    id:                      number;
    origem:                  string;
    created_at:              Date;
    projeto_id:              number;
    quantidade:              number;
    updated_at:              Date;
    componente_id:           number;
    dados_migracao:          null;
    valor_unitario:          number;
    user_guilted_id:         number;
    valor_unitario_original: number;
    categoria_componentes_id: number;
    nome:                    string;
    modelo:                  string;
}

export type TPedidosHistoricosNotasFiscais = {
    itens:             TPedidosHistoricosNotasFiscaisItem[];
    serie:             number;
    valor:             number;
    numero:            number;
    origem:            string;
    situacao:          string;
    peso_bruto:        number;
    data_criacao:      Date | string;
    data_emissao:      Date | string;
    dados_migracao:    object;
    chave_acesso_nfe:  string;
    natureza_operacao: string;
}

export type TPedidosHistoricosNotasFiscaisItem = {
    id:         number;
    nome:       string;
    valor:      number;
    codigo:     string;
    quantidade: number;
}

export type TPedidosHistoricosRastreamento = {
    observacao:          string;
    ocorrencia:          string;
    link_rastreio:       string;
    data_rastreamento:   Date | string;
    id_transportadora:   number;
    status_finalizador:  boolean;
    cnpj_transportadora: string;
    nome_transportadora: string;
}

export type TCategoriasComponentes = {
    id:                      number;
    nome:                    string;
    grupo:                   string;
    considerar_peso_telhado: boolean;
    ordem_listagem:          number;
    created_at:              Date | string;
    updated_at:              Date | string;
}

export interface IFaturamentoTipos {
  id: FaturamentoType;
  title: string;
  subtitle?: string;
  modal: { imgUrl: string; title: string; },
  disable?: boolean,
}

export const FATURAMENTO_TIPOS: IFaturamentoTipos[] = [
  { id: 'cliente', title: 'Para cliente final', modal: { imgUrl: ClienteFinal, title: 'Para cliente final' } },
  { id: 'integrador', title:'Para revenda', modal: { imgUrl: IntegradorSolar, title: 'Para revenda' } },
  { id: 'integrador_cliente', title: 'Operação triangular / venda à ordem', subtitle: 'Faturamento para revenda, com entrega no cliente final', modal: { imgUrl: IntegradorSolarClienteFinal, title: 'Operação triangular / venda à ordem' } },
]

export type FormProjetoOffGridValidationsType = {
    tipo_bateria: { status: boolean; helper: string }
    autonomia_bancos_bateria: { status: boolean; helper: string },
    modulo: { status: boolean; helper: string },
    estrutura: { status: boolean; helper: string },
    fileiras: { status: boolean; helper: string },
}

export interface FormProjetoOffGridModalsType {
    equipamentos: boolean;
    drawerInformacoes: boolean;
}

export type EquipamentoOffGrid = {
    id?: number;
    potencia: number;
    quantidade: number;
    horas_uso: number;
    nome: string
    consumo_diaria: number
    '@remove'?: boolean;
    '@new'?: boolean;
}

export interface CustomModuloPorRegiaoListagemResponseWithQuantity extends ModuloPorRegiaoListagemResponse {
    quantidade: number;
    selecionado: boolean;
}

export interface ComponenteSolucaoOffGrid {
    id: number
    componente_id: number;
    categoria_componentes_id: number
    modelo: string
    nome: string
    nome_componente: string
    descricao: string
    descricao_componente: string
    segmento: string
    peso: number
    tempo_garantia: number
    tempo_garantia_unidade: string
    venda: string
    considerar_calculo: boolean
    exibir_listagem: boolean
    comprimento: number
    largura: number
    altura: number
    origem: string
    unidade_medida: string
    grupo_mercadoria: string
    parceiro_id: number
    exibir_popup_parceiro: boolean
    descricao_garantia: string
    created_at: string
    updated_at: string
    atributos: Atributo[]
    tipo: number
    tensao_nominal: number
    capacidade: number
    potencia: number
    valorCalculoQuantidade: number
    potencia_maxima_total: number
    quantidade: number
    valor: number
}

export interface SolucaoCalculadaOffGrid {
    baterias: ComponenteSolucaoOffGrid[]
    controladores: ComponenteSolucaoOffGrid[]
    inversores: ComponenteSolucaoOffGrid[]
    modulo: {
        alterouQuantidade: boolean;
        quantidade: number;
    } | null;
}

export type TiposBaterias = "litio" | "chumbo"

export type FormProjetoOffGridType = {
    id?: number,
    tipo_bateria: { id: TiposBaterias; nome: string } | null
    cep_encontrado: boolean,
    regioes: number[],
    codigo_venda: string | null,
    servico: ProjetoServico,
    titulo: string | null,
    segmento: 'distribuicao_offgrid',

    geracao_necessaria_w: number,
    geracao_necessaria_kw: number,

    valor: number,
    valor_servico: number,
    valor_servico_pis_cofins: number,
    codigo_servico?: string,
    cliente_proposta: string,
    email_proposta: string,
    cpf_cnpj_proposta: string,
    telefone_proposta: string,
    endereco_proposta: string,
    distribuidor_id: number,
    
    distribuidor: {
        id: number
        cnpj_cpf: string
        nome: string
        fantasia: string
    } | null,
    
    cidade_id?: number,
    cidade?: Cidade | null;

    estado_id?: string;
    estado?: { id: string, nome?: string } | null;
    estado_original?: { id: string, nome?: string } | null; 

    revenda_id?: number | null;
    revenda?: Conta | null;

    supervisor_id?: number | null,
    ev_id?: number | null,
    ev?: Conta | null,

    analista_id: number | null,
    analista: Conta | null,
    
    assistente_id?: number | null;
    assistente?: Conta;

    cep: string,
    numero: string,
    bairro:  string,

    modulo_selecionado: Omit<ModuloListagem, "selecionado"> | null, 
    modulos: (Omit<ModuloListagem, "selecionado">)[],
    inversores: any[],

    tipo_proposta: Option<PropostaValueType> | null;

    acessorios: ListagemItem[],

    tipo: 'dimensionado',

    recebe_servico: boolean,

    latitude: number,
    longitude: number,

    fator_demanda?: string | null
    autonomia_banco_bateria: number | null
    tensao_saida: { id: string, nome: string } | null

    estruturas_calculadas: ListagemItem[],
    isEdit: boolean,

    clonar_projeto: boolean;

    vendedor_interno?: Option<number>,
    
    endereco?: string,

    isTrocaUf?: boolean
    isTrocaModulo?: boolean
    isTrocaPotencia?: boolean

    equipamentos: EquipamentoOffGrid[]
    total_consumo_diario_w: number,
    total_consumo_diario_kw: number,

    estrutura_selecionada: EstruturaListagemResponse | null;  
    estruturas: EstruturaListagemResponse[]
    todas_estruturas: EstruturaListagemResponse[]

    reativar?: boolean
    recalcular?: boolean

    potencia_fotovoltaica: number;

    solucao_calculada: SolucaoCalculadaOffGrid;

    baterias: Bateria[]

    valor_minimo_servico: number

    resultado_calculos: ResultadoCalculos | null

    fileiras: Fileira[];

    justificativa_valor_servico?: string | null;
    
    old_componentes_edicao: ComponenteProjetoComQuantidade[]
    old_estado_id: string;

    listagem_baterias_status: boolean;
}

export enum VENDA {
    GERADOR = "gerador",
    AVULSO = "avulso",
}

